module.exports = __webpack_public_path__ + "img/twitter-mob.ede6023d.svg";